import { supabase } from '../lib/supabase';

export const messageTemplateService = {
  // Get all message templates
  async getTemplates(filters = {}) {
    try {
      let query = supabase?.from('message_templates')?.select('*');

      if (filters?.type) {
        query = query?.eq('type', filters?.type);
      }
      if (filters?.category) {
        query = query?.eq('category', filters?.category);
      }
      if (filters?.projectId) {
        query = query?.eq('project_id', filters?.projectId);
      }
      if (filters?.isActive !== undefined) {
        query = query?.eq('is_active', filters?.isActive);
      }

      query = query?.order('created_at', { ascending: false });

      const { data, error } = await query;

      if (error) throw error;

      return data?.map(template => ({
        id: template?.id,
        name: template?.name,
        type: template?.type,
        category: template?.category,
        subject: template?.subject,
        content: template?.content,
        variables: template?.variables,
        isActive: template?.is_active,
        projectId: template?.project_id,
        createdBy: template?.created_by,
        createdAt: template?.created_at,
        updatedAt: template?.updated_at
      }));
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  },

  // Get single template
  async getTemplate(templateId) {
    try {
      const { data, error } = await supabase
        ?.from('message_templates')
        ?.select('*')
        ?.eq('id', templateId)
        ?.single();

      if (error) throw error;

      return {
        id: data?.id,
        name: data?.name,
        type: data?.type,
        category: data?.category,
        subject: data?.subject,
        content: data?.content,
        variables: data?.variables,
        isActive: data?.is_active,
        projectId: data?.project_id,
        createdBy: data?.created_by,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error fetching template:', error);
      throw error;
    }
  },

  // Create message template
  async createTemplate(templateData) {
    try {
      const { data, error } = await supabase
        ?.from('message_templates')
        ?.insert({
          name: templateData?.name,
          type: templateData?.type,
          category: templateData?.category,
          subject: templateData?.subject,
          content: templateData?.content,
          variables: templateData?.variables || [],
          is_active: templateData?.isActive !== undefined ? templateData?.isActive : true,
          project_id: templateData?.projectId,
          created_by: templateData?.createdBy
        })
        ?.select()
        ?.single();

      if (error) throw error;

      return {
        id: data?.id,
        name: data?.name,
        type: data?.type,
        category: data?.category,
        subject: data?.subject,
        content: data?.content,
        variables: data?.variables,
        isActive: data?.is_active,
        projectId: data?.project_id,
        createdBy: data?.created_by,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error creating template:', error);
      throw error;
    }
  },

  // Update message template
  async updateTemplate(templateId, updates) {
    try {
      const { data, error } = await supabase
        ?.from('message_templates')
        ?.update({
          name: updates?.name,
          type: updates?.type,
          category: updates?.category,
          subject: updates?.subject,
          content: updates?.content,
          variables: updates?.variables,
          is_active: updates?.isActive,
          project_id: updates?.projectId
        })
        ?.eq('id', templateId)
        ?.select()
        ?.single();

      if (error) throw error;

      return {
        id: data?.id,
        name: data?.name,
        type: data?.type,
        category: data?.category,
        subject: data?.subject,
        content: data?.content,
        variables: data?.variables,
        isActive: data?.is_active,
        projectId: data?.project_id,
        createdBy: data?.created_by,
        createdAt: data?.created_at,
        updatedAt: data?.updated_at
      };
    } catch (error) {
      console.error('Error updating template:', error);
      throw error;
    }
  },

  // Delete message template
  async deleteTemplate(templateId) {
    try {
      const { error } = await supabase
        ?.from('message_templates')
        ?.delete()
        ?.eq('id', templateId);

      if (error) throw error;
    } catch (error) {
      console.error('Error deleting template:', error);
      throw error;
    }
  },

  // Process template with variables
  async processTemplate(templateId, variablesData) {
    try {
      const { data, error } = await supabase
        ?.rpc('process_message_template', {
          template_id: templateId,
          variables_data: variablesData
        });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Error processing template:', error);
      throw error;
    }
  },

  // Get template categories
  getCategories() {
    return [
      { value: 'welcome', label: 'Bienvenida' },
      { value: 'follow_up', label: 'Seguimiento' },
      { value: 'reminder', label: 'Recordatorio' },
      { value: 'promotion', label: 'Promoción' },
      { value: 'thank_you', label: 'Agradecimiento' },
      { value: 'custom', label: 'Personalizado' }
    ];
  },

  // Get template types
  getTypes() {
    return [
      { value: 'whatsapp', label: 'WhatsApp', icon: 'MessageCircle' },
      { value: 'email', label: 'Email', icon: 'Mail' },
      { value: 'sms', label: 'SMS', icon: 'Smartphone' },
      { value: 'notification', label: 'Notificación', icon: 'Bell' }
    ];
  }
};

export default messageTemplateService;